import { Injectable } from '@angular/core';

import { AclAccess, AclEntry, AclRequire, FsAcl } from '@firestitch/acl';
import { FsStore } from '@firestitch/store';

import { AclPermission } from '@app/common/enums';


@Injectable({
  providedIn: 'root',
})
export class AclService {

  constructor(
    private _store: FsStore,
    private _acl: FsAcl,
  ) {
    this._store.observe('permissions')
      .subscribe((event: any) => {
        const entries: AclEntry[] = [];
        if (event.value) {
          event.value.forEach((objectPermission) => {
            objectPermission.permissions.forEach((permission) => {
              entries.push({
                objectId: objectPermission.objectId,
                permissions: [
                  {
                    value: permission.value,
                    access: permission.access,
                  },
                ],
              });
            });
          });
        }

        _acl.setEntries(entries);
      });
  }

  public isAdmin(): boolean {
    return this.hasPermissionAdmin();
  }

  public hasPermissionAdmin(): boolean {
    return this._acl.has(AclPermission.Admin);
  }

  public hasPermissionSystem(): boolean {
    return this._acl.has(AclPermission.System);
  }

  public hasRead(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Read, object, aclRequire);
  }

  public hasWrite(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Write, object, aclRequire);
  }

  public hasFull(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Full, object, aclRequire);
  }

  public has(permissions: string[] | string, access?: AclAccess, objects?: any, aclRequire?: AclRequire): boolean {
    return this.isAdmin() || this._acl.has(permissions, access, objects, aclRequire);
  }

}
